import { Theme } from "@mui/material";
import { Device } from "@services/devices/types";

export type DeviceStatusType =
  | "default"
  | "meeting"
  | "error"
  | "disconnected"
  | "Asset"
  | "unknown";

export const isPaused = (device: Device) => {
  const monitored = device?.status?.pauseMonitoringStatus;
  return (
    monitored?.paused || monitored?.parentPaused || monitored?.outOfSchedule
  );
};

export const DeviceType = {
  ASSET: "Asset",
};
export const getStatusSxColorFn =
  (status?: DeviceStatusType) =>
  ({ palette }: Theme) => {
    switch (status) {
      case "meeting":
        return palette.meeting.background;
      case "error":
        return palette.ticket.Critical.dark;
      case "disconnected":
      case "Asset":
        return palette.background.highlighter;
      case "unknown":
        return palette.common.grey.g474a53;
      case "default":
      default:
        return palette.device.border;
    }
  };
